export var LogLevel = /*#__PURE__*/function (LogLevel) {
  LogLevel["Trace"] = "trace";
  LogLevel["Info"] = "info";
  LogLevel["Warn"] = "warn";
  LogLevel["Error"] = "error";
  return LogLevel;
}(LogLevel || {});

